import Image from "next/image";
import Popup from "../Popup/Popup";
import styles from "./ChatEndPopup.module.scss";
import { END_CALL_ICON, IC_CROSS } from "@/utils/imageRelativePaths";

type Props = {
  show: boolean;
  onClose: () => void;
  onEnd: () => void;
};

const ChatEndPopup = ({ show, onClose, onEnd }: Props) => {
  return (
    <Popup show={show} onClose={onClose}>
      <div className={styles.chat_end_popup}>
        <div className={styles.icon_section}>
          <Image
            src={END_CALL_ICON}
            alt="icon end call"
            height={44}
            width={44}
          />
        </div>
        <div className={styles.text}>
          Are you sure you want to end this chat and start a new one?
        </div>
        <div className={styles.btn_section}>
          <button className={styles.btn_no} onClick={onClose}>
            No
          </button>
          <button className={styles.btn_yes} onClick={onEnd}>
            yes
          </button>
        </div>
        <Image
          src={IC_CROSS}
          alt="close ic"
          height={10}
          width={10}
          className={styles.close_icon}
          onClick={onClose}
        />
      </div>
    </Popup>
  );
};

export default ChatEndPopup;
